module.exports = __webpack_public_path__ + "static/media/AdditionalStopIcon.bd3567d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/google-map/AdditionalStopIcon.svg
// module id = 1467
// module chunks = 0